import { useEffect } from 'react';
import { EventContextType } from '../providers';
import { SubscriptionCallback, SubscriptionChannelEventSchema, SubscriptionOptions } from '../types';
import { useEventSubscription } from './useEventSubscription';

/**
 * Subscribes to a subscription event for as long as the component is mounted
 */
export function useComponentEventSubscription<T extends SubscriptionChannelEventSchema>(
  context: React.Context<EventContextType>,
  options: SubscriptionOptions<T>,
  onSuccess: SubscriptionCallback<T>,
  onError?: (result: Error) => void,
  onComplete?: () => void,
) {
  const { subscribe } = useEventSubscription(context);

  useEffect(() => {
    const { unsubscribe } = subscribe({ ...options, continueWhenNotConnected: true }, onSuccess, onError, onComplete);
    return () => {
      unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options, context]);
}
